import React from 'react';
import Image from 'apps/new-web/views/components/image';
import I18n from 'apps/new-web/views/components/i18n';

const HeaderNav = () => (
  <nav className="header-nav">
    <Image src="/img/ifit-logo-dark-mc.svg" alt="iFIT" />
    <a href="/">
      <I18n desc="Link inviting user to get more information." args={{ ifit: 'iFIT' }}>Learn more about [ifit]</I18n>
    </a>
  </nav>
);

export default HeaderNav;
